import { useState, useEffect } from 'react'
import { GET_LIST } from 'react-admin'
import rolesRoute from '../providers/module/roles'

const useProgramsList = () => {
  const [arrayPrograms, setArrayPrograms] = useState([])

  useEffect(() => {
    (async () => {
      const programsList = await rolesRoute(GET_LIST, 'programs')
      setArrayPrograms(programsList.data)
    })()
  }, [])

  return arrayPrograms
}

export default useProgramsList
